import { render, staticRenderFns } from "./OrderRecipient.vue?vue&type=template&id=12af20ec&scoped=true"
import script from "./OrderRecipient.vue?vue&type=script&lang=js"
export * from "./OrderRecipient.vue?vue&type=script&lang=js"
import style0 from "./OrderRecipient.vue?vue&type=style&index=0&id=12af20ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12af20ec",
  null
  
)

export default component.exports